<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-file-account"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row style="height: 600px">
        <v-col class="white rounded-lg" cols="8">
          <v-row class="mt-1">
            <v-col class="pl-10 text-left" cols="3">Full name:</v-col>
            <v-col cols="9">{{ cvDetail.name }}</v-col>
          </v-row>
          <v-row class="mt-1">
            <v-col class="pl-10 text-left" cols="3">Phone number:</v-col>
            <v-col cols="9">{{ cvDetail.phone }}</v-col>
          </v-row>
          <v-row class="mt-1">
            <v-col class="pl-10 text-left" cols="3">Email:</v-col>
            <v-col cols="9">{{ cvDetail.email }}</v-col>
          </v-row>
          <v-row class="mt-1">
            <v-col class="pl-10 text-left" cols="3">Location:</v-col>
            <v-col cols="9">{{ cvDetail.location }}</v-col>
          </v-row>
          <v-row class="mt-1">
            <v-col class="pl-10 text-left" cols="3">Comment:</v-col>
            <v-col cols="9">{{ cvDetail.comment }}</v-col>
          </v-row>
          <v-row class="mt-1 mb-1">
            <v-col class="pl-10 text-left" cols="3">File CV:</v-col>
            <v-col cols="9"><a v-if="cvDetail.files &&cvDetail.files.path" :href="this.url+`/${cvDetail.files.path}`"
                               target="_blank">{{ cvDetail.files.name }}</a></v-col>
          </v-row>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_DETAIL_CV} from "@/store/modules/cv";

export default {
  name: "CV_detail",
  data() {
    return {
      page: "Chi tiết",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "CV",
          disabled: true,
        },
        {
          text: "Chi tiết",
          disabled: true,
        },
      ],
      url:''
    }
  },
  computed: {
    ...mapGetters({
      cvDetail: "cvDetail",
    })
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(`${GET_DETAIL_CV}`, this.$route.params.id).then(data => {
      if (data) {
        console.log(data)
      }
    });
  },
}
</script>

<style scoped lang="scss">
.text-left{
  color: #6F6F71;
}
</style>